<template>
  <base-jin-nang-panel title="锦囊申请" :back-href="JinNangIndexRoute">
    <template v-slot:bodyContent>
      <div class="container">
        <div class="item mb30">
          <div class="icon-suc"></div>
        </div>
        <div class="item mb28 result-title">提交申请成功</div>
        <div class="item mb18 sub-title">
          工作人员将在三个工作日内通知您，请耐心等待
        </div>
        <div class="item mb55 sub-title">客服电话：400-602-1010</div>
        <div class="item">
          <div class="com-btn" @click="gotoIndex">完成</div>
        </div>
      </div>
    </template>
  </base-jin-nang-panel>
</template>

<script>
import BaseJinNangPanel from '../BaseJinnangPanel/BaseJinNangPanel.vue'

export default {
  name: 'ApplicationResult',
  components: { BaseJinNangPanel },
  props: {},
  data() {
    return {
      JinNangIndexRoute: '/excl-author/jinnang'
    }
  },
  methods: {
    gotoIndex() {
      this.$router.push(this.JinNangIndexRoute)
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 45px 0px 290px 0px;
}

.icon-suc {
  width: 90px;
  height: 90px;
  background-image: url('~@/assets/images/jinnang/apply-suc.png');
}

.mb30 {
  margin-bottom: 30px;
}
.mb28 {
  margin-bottom: 28px;
}
.mb18 {
  margin-bottom: 18px;
}
.mb55 {
  margin-bottom: 55px;
}
.result-title {
  font-family: MicrosoftYaHei;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #262626;
}

.sub-title {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #858585;
}
.com-btn {
  width: 180px;
  height: 44px;
  background-color: #046bcc;
  border-radius: 5px;
  font-family: MicrosoftYaHei;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
}
</style>
